import { render, staticRenderFns } from "./aboutQDS.vue?vue&type=template&id=11d61e79&scoped=true&"
import script from "./aboutQDS.vue?vue&type=script&lang=js&"
export * from "./aboutQDS.vue?vue&type=script&lang=js&"
import style0 from "./aboutQDS.vue?vue&type=style&index=0&id=11d61e79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d61e79",
  null
  
)

export default component.exports